// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../contexts/AuthProvider/AuthProvider";
// import { rolesDashboards } from "./rolesDashboard";

// export const PublicRoute: React.FC<{ children: React.ReactNode }> = (props) => {
//   const { user, isLogin, token } = useAuth();

//   if (isLogin && token) {
//     const path = rolesDashboards[user.role as "ADMIN"];
//     if (path) {
//       return <Navigate to={path} />;
//     } else {
//       return <Navigate to={"/dashboard"} />;
//     }
//   }
//   return <>{props.children}</>;
// };

// In PublicRoute.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider/AuthProvider";
import { rolesDashboards } from "./rolesDashboard";

export const PublicRoute: React.FC<{ children: React.ReactNode }> = (props) => {
  const { user, isLogin, token } = useAuth();
  const location = useLocation();

  // Check if this is the signup flow
  const isSignupFlow =
    location.pathname.includes("/auth/signup/setup-company") ||
    location.pathname.includes("/auth/signup-v2") ||
    location.pathname.includes("/signup-choose-subscription-billing");

  if (isLogin && token) {
    // If user is in signup flow, don't redirect to dashboard
    if (isSignupFlow) {
      return <>{props.children}</>;
    }

    // Normal redirect for authenticated users
    const path = rolesDashboards[user.role as "ADMIN"];
    if (path) {
      return <Navigate to={path} />;
    } else {
      return <Navigate to={"/dashboard"} />;
    }
  }

  return <>{props.children}</>;
};
